import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { systemConfigQueryKeys } from "../Services/system_config_service";
import type { SystemConfig } from "../Types/SystemConfig";

export const useConfigSync = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleStorage = (e: StorageEvent) => {
      if (e.key === "system_config_cache" && e.newValue) {
        try {
          const fresh = JSON.parse(e.newValue) as SystemConfig;
          queryClient.setQueryData(systemConfigQueryKeys.systemConfig(), {
            success: true,
            data: fresh,
          });
        } catch {}
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, [queryClient]);

  useEffect(() => {
    const handleCustom = (e: CustomEvent) => {
      if (e.detail?.type === "systemConfigUpdated" && e.detail.config) {
        queryClient.setQueryData(systemConfigQueryKeys.systemConfig(), {
          success: true,
          data: e.detail.config,
        });
      }
    };
    window.addEventListener(
      "systemConfigUpdated",
      handleCustom as EventListener,
    );
    return () =>
      window.removeEventListener(
        "systemConfigUpdated",
        handleCustom as EventListener,
      );
  }, [queryClient]);

  const notifyConfigChange = (config: SystemConfig) => {
    window.dispatchEvent(
      new CustomEvent("systemConfigUpdated", {
        detail: { type: "systemConfigUpdated", config },
      }),
    );
  };

  return { notifyConfigChange };
};
